import { CloseSharp } from "@mui/icons-material";
import { Box, Button, FormLabel, Stack } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import Schema from "../../schema";
import BrandAutoCompleteDropdown from "../../pages/company-wishlist/BrandAutoCompleteDropdown";
import { getAllBrandsforListing } from "../../pages/brands/action";
import { useEffect, useState } from "react";
import CustomTextArea from "../inputs/textarea";
import instagramIcon from '../../assets/images/icons/instaIcon.svg'
import youTubeIcon from '../../assets/images/icons/YouTube2.svg'
import { addEditWishlistReducer } from "../../pages/company-wishlist/addEditWishlistSlice";
import { useCreateWishlistMutation } from "../../redux/api";
import CustomizedSnackbars from "../snackbar";
import { useNavigate } from "react-router-dom";
import { setSearchdata } from "../../utils/common";
import { updateDashboard } from "../../pages/dashboard/dashboardSlice";
import { getInfluencerListFordashboard } from "../../pages/dashboard/action";
import { FORM_INPUTFIELD_STYLES } from "../../utils/constant";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiPaper-root': {
        width: '880px',
        maxWidth: '1000px !important',
        height: '420px',
        padding: '24px',
        BorderRadius: '16px',
    },
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const CreateWishlistModal = (props) => {
    const { open, setOpen,setActionDropdownState=()=>{},setSelectedWishlistForAction=()=>{} } = props;
    const navigate = useNavigate();
    const [snackbar, setSnackbar] = useState({
        message: "",
        severity: "success",
        open: false,
    });
    const handleClose = () => {dispatch(addEditWishlistReducer({ name: "", brandId: null, platform: "", color: "", id: "" }));setOpen(false)};
    const [createWishlist] = useCreateWishlistMutation();
    const dispatch = useDispatch();
    const {
        listing,
    } = useSelector((state) => state.brandSlice);
    const {limit} = useSelector((state)=>state.dashboardSlice)
    const {
        name, brandId, platform, color, id
    } = useSelector((state) => state.addEditWishlist);
    useEffect(() => {
        dispatch(getAllBrandsforListing());
    }, [])


    const chooseColorButtonFillColors = ["#FF5630", "#FFAB00", "#569733", "#23A9F6", "#22C2DE", "#0052CC", "#6554C0", "#F45290", "#000000"]

    return (
        <><CustomizedSnackbars msgData={snackbar} setMsgData={setSnackbar} />
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}>
                <Stack direction="column" spacing={0}>
                    <Stack
                        sx={{
                            border: '0px solid red'
                        }}
                        direction="row"
                        justifyContent={"space-between"}
                        alignItems={"center"}>
                        <Typography
                            sx={{ fontSize: '24px', fontWeight: '600', color: '#000' }}
                            id="customized-dialog-title">
                            {Boolean(id) ? "Update List" : "Create List"}
                        </Typography>
                        <div className="cursorPointer" onClick={handleClose}>
                            <CloseSharp sx={{ color: "#000", fontSize: '20px', fontWeight: '600' }} />
                        </div>
                    </Stack>
                    <Formik
                        initialValues={{ name, brandId, platform, color, id }}
                        enableReinitialize={true}
                        validateOnChange={true}
                        validationSchema={Schema.createWishlist}
                        onSubmit={async (values) => {
                            try {
                                const isUpdate = Boolean(values.id);
                                const endpoint = isUpdate ? "/wishlist/update" : "/wishlist/create";
                                const method = isUpdate ? "PUT" : "POST"
                                const res = await createWishlist({ endpoint, method, body: { name: values.name, brandId: values.brandId, platform: values.platform, color: values.color, ...(isUpdate && { id: values.id }) } }).unwrap();
                                if (res.status == "SUCCESS") {
                                    setSnackbar({
                                        message: res.message,
                                        severity: "success",
                                        open: true,
                                    });
                                   if(!isUpdate){ const jsonString = JSON.stringify({ platform: "Instagram", categories: [] });
                                    setSearchdata(jsonString);
                                    dispatch(
                                        updateDashboard({
                                            filters: { platform: "Instagram", categories: [] },
                                            search: "",
                                            list: [], limit: limit || 20, totalCount: 0, page: 1, showLoading: true,
                                        }),
                                    );
                                    dispatch(getInfluencerListFordashboard());
                                    setActionDropdownState(null);
                                    setSelectedWishlistForAction(null);
                                    navigate(`/list/listing?wishlistId=${res.result.id}`)}
                                    dispatch(addEditWishlistReducer({ name: "", brandId: null, platform: "", color: "", id: "" }));
                                    setOpen(false);
                                } else {
                                    setSnackbar({
                                        message: res.message,
                                        severity: "error",
                                        open: true,
                                    });
                                }
                            } catch (error) {
                                setSnackbar({
                                    message: "Something went wrong",
                                    severity: "error",
                                    open: true,
                                });
                            }
                        }}>
                        {({
                            errors,
                            handleChange,
                            handleSubmit,
                            touched,
                            values,
                        }) => {
                            const handleTrimmedChange = (e) => {
                                const { name, value } = e.target;
                                handleChange({
                                    target: {
                                        name,
                                        value: value.replace(/^\s+/, ''),
                                    },
                                });
                            };
                            return (
                                <Form
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        handleSubmit(e);
                                    }}>
                                    <Stack direction="column" gap={2.5} sx={{ border: '0px solid pink', marginTop: '40px' }}>
                                        <Stack direction="row" gap="6%">
                                            <Box sx={{ width: '47%', }}>
                                                <FormLabel required sx={{ marginBottom: '12px', fontSize: '16px', fontWeight: '400', color: '#000' }}>List Name</FormLabel>
                                                <CustomTextArea
                                                    name={"name"}
                                                    type={"text"}
                                                    label={("")}
                                                    sx={FORM_INPUTFIELD_STYLES}
                                                    sizeval="medium"
                                                    values={values.name}
                                                    placeholder={"Enter List Name"}
                                                    onChange={handleTrimmedChange}
                                                    focused={false}
                                                    style={{ m: 0, p: 0, height: '48px !important', maxHeight: '48px !important' }}
                                                />
                                                <Typography className="error">{Boolean(touched.name) && errors.name}</Typography>
                                            </Box>
                                            <Box sx={{ width: '47%', }}>
                                                <FormLabel required sx={{ marginBottom: '12px', fontSize: '16px', fontWeight: '400', color: '#000' }}>Choose Platform</FormLabel>
                                                <Stack direction="row" justifyContent="flex-start" gap={2} alignItems={"center"} sx={{ height: '44px !important', border: '0px solid green', padding: '0', margin: '0' }}>
                                                    <Button value="Instagram" name="platform" onClick={handleChange} sx={{ "&:focus": { border: '0px !important' }, height: '36px', width: '130px', padding: '8px 12px', border: '1px solid #B5B3B3', borderRadius: '4px', background: values.platform === 'Instagram' ? 'var(--color-blue)' : 'white', color: values.platform === 'Instagram' ? 'white' : 'black', fontSize: '16px', fontWeight: '400', "&:hover": { border: '1px solid var(--color-blue) !important', background: 'var(--color-blue) !important', color: 'white !important' } }}><img src={instagramIcon} style={{ width: '20px', height: '20px' }} alt="" />&nbsp;&nbsp;Instagram</Button>
                                                    <Button value="Youtube" name="platform" onClick={handleChange} sx={{ "&:focus": { border: '0px !important' }, height: '36px', width: '130px', padding: '8px 12px', border: '1px solid #B5B3B3', borderRadius: '4px', background: values.platform === 'Youtube' ? 'var(--color-blue)' : 'white', color: values.platform === 'Youtube' ? 'white' : 'black', fontSize: '16px', fontWeight: '400', "&:hover": { border: '1px solid var(--color-blue) !important', background: 'var(--color-blue) !important', color: 'white !important' } }}><img src={youTubeIcon} style={{ width: '20px', height: '20px' }} alt="" />&nbsp;&nbsp;Youtube</Button>
                                                </Stack>
                                                <Typography className="error">{Boolean(touched.platform) && errors.platform}</Typography>
                                            </Box>
                                        </Stack>
                                        <Stack direction="row" gap="6%">
                                            <Box sx={{ width: '47%', }}>
                                                <FormLabel required sx={{ marginBottom: '12px', fontSize: '16px', fontWeight: '400', color: '#000' }}>Brand</FormLabel>
                                                <BrandAutoCompleteDropdown  type="wishlist"
                                                    handleChange={(e, newValue) => {
                                                        handleChange({
                                                            target: { name: "brandId", value: newValue?.id || null },
                                                        });
                                                    }}
                                                    values={
                                                        listing
                                                            ? listing
                                                                .map((i) => ({ name: i.brandName, id: i.id, image: i.brandImage }))
                                                                .find((b) => b.id === values.brandId)
                                                            : null
                                                    }

                                                    brandList={listing} />
                                                <Typography className="error">{Boolean(touched.brandId) && errors.brandId}</Typography>
                                            </Box>
                                            <Box sx={{ width: '47%', }}>
                                                <FormLabel required sx={{ marginBottom: '12px', fontSize: '16px', fontWeight: '400', color: '#000' }}>Choose Color</FormLabel>
                                                <Stack direction="row" justifyContent="flex-start" gap={1.5} alignItems={"center"} sx={{
                                                    height: '44px !important'
                                                }}>
                                                    {
                                                        chooseColorButtonFillColors.map((color) => <Button name="color" onClick={handleChange} value={color} sx={{ minWidth: '20px', height: '20px', borderRadius: '50%', width: '20px', border: `2px solid ${color}`, background: color, padding: '10px !important', position: 'relative', "&::before": { border: `2px solid ${color}`, position: 'absolute', content: '""', borderRadius: '50%', background: 'transparent', width: '160%', height: '160%', display: values.color === color ? 'block' : 'none' }, "&:hover": { background: color, "&::before": { display: 'block' } } }}></Button>)
                                                    }

                                                </Stack>
                                                <Typography className="error">{Boolean(touched.color) && errors.color}</Typography>
                                            </Box>
                                        </Stack>
                                    </Stack>
                                    <Stack direction="row" justifyContent="flex-end" spacing={2} sx={{ marginTop: '40px', border: '0px solid' }}>
                                        <Button onClick={handleClose} sx={{
                                            "&:hover": {
                                                border: '1px solid #AAAAAA !important', color: '#000', background: 'white'
                                            }, "&:focus": {
                                                border: '0px !important',
                                            },
                                            width: '133px', height: '44px', borderRadius: '8px', border: '1px solid #AAAAAA', color: '#AAAAAA', fontWeight: '600'
                                        }}>Cancel</Button>
                                        <Button type="submit" sx={{
                                            "&:hover": {
                                                border: '0px !important',
                                            }, "&:focus": {
                                                border: '0px !important',
                                            }, position: 'relative', padding: '1px', width: '133px', height: '44px', borderRadius: '8px', border: '0px solid #AAAAAA', color: '#AAAAAA', background: 'linear-gradient(124deg,rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)'
                                        }}>
                                            <Box sx={{
                                                "&:hover": {
                                                    background: 'transparent', color: 'white'
                                                },
                                                width: '100%', height: '100%', background: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '8px', fontWeight: '600'
                                            }}>
                                                Next
                                            </Box>
                                        </Button>
                                    </Stack>
                                </Form>
                            );
                        }}
                    </Formik >
                    <Stack>
                    </Stack>
                </Stack>
            </BootstrapDialog>
        </>
    )
}

export default CreateWishlistModal